/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RegisterUserDataParser = /* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['password', codecString],
    ['email', codecString],
    ['name', codecString],
    ['tenantId', codecString, 'tenant_id'],
]);
export class RegisterUserData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RegisterUserDataParser.decode(input).map(res => new RegisterUserData(res));
    }
    static unsafeDecode(input) {
        return RegisterUserData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RegisterUserDataParser.encode(data);
    }
    static schema() {
        return RegisterUserDataParser.schema();
    }
}
